import { Link } from "react-router-dom";
import "../Styles/DropdownMenu.css"
import {
  SlidersHorizontal,
  CircleUserRound,
  LogOut
} from "lucide-react";
import { useAuth } from "../Services/AuthContext";
import GoingOutStatusControl from "./GoingOut/GoingOutStatusControl";

type DropdownMenuProps = {
  onNavigate?: () => void;
};

export default function DropdownMenu({ onNavigate }: DropdownMenuProps) {
    const {user, logout} = useAuth();

     const handleLogout = () => {
        logout();
        onNavigate?.();
        };
    return (
        <div className="dropdown-menu">
            {/* Kartan slutar fråga så fort man svarat. Det här är ett av
                de två ställen svaret går att ändra på resten av natten. */}
            <GoingOutStatusControl variant="menu" />

            <Link to={user ? `/profile/${user.id}` : "/profile"} className="dropdown-item" onClick={onNavigate}><CircleUserRound size={16} strokeWidth={1.9}></CircleUserRound>Profile</Link>
            <Link to="/settings" className="dropdown-item" onClick={onNavigate}><SlidersHorizontal size={16} strokeWidth={1.9}></SlidersHorizontal>Settings</Link>
            <button className="dropdown-item" onClick={handleLogout}><LogOut size={16} strokeWidth={1.9} />Logout</button>

        </div>
    );
}
